const allowedFormats = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];

/**
 * Validates an image file's format and dimensions
 * @param {File} file - The image file
 * @param {number} width - Required width
 * @param {number} height - Required height
 * @param {(error: string|null) => void} callback - Callback to return error or success
 */
export function validateImageFile(file, width, height, callback) {
    if (!allowedFormats.includes(file.type)) {
        callback("Only JPG, PNG, JPEG, and SVG formats are allowed.");
        return;
    }

    // Skip dimension check for SVG as it's vector-based
    if (file.type === 'image/svg+xml') {
        callback(null);
        return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
        if (img.width !== width || img.height !== height) {
            callback(`Image must be exactly ${width}x${height} pixels.`);
        } else {
            callback(null);
        }
    };
    img.onerror = () => {
        callback("Invalid image file.");
    };
}

export function validateSquareImageFile(file, callback) {
    if (!allowedFormats.includes(file.type)) {
        callback("Only JPG, PNG, JPEG, and SVG formats are allowed.");
        return;
    }

    // Skip dimension check for SVG as it's vector-based
    if (file.type === 'image/svg+xml') {
        callback(null);
        return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
        if (img.width !== img.height) {
            callback("Image must have a 1:1 aspect ratio (width and height should be equal).");
        } else {
            callback(null);
        }
    };
    img.onerror = () => {
        callback("Invalid image file.");
    };
}